import PropTypes from 'prop-types';
import { Component } from 'react';
import { DEFAULT_REGISTRY } from '../../utils/defaults';
import { getDefaultValue } from '../../utils/additionalPropertyUtils';

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import UnderConstruction from '../../../Doc/components/UnderConstruction';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import NumberInput from '../inputs/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class IntegerField extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = value => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onChange(Math.floor(value));
    };
    this.getPlaceholder = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        isAdditionalProperty,
        placeholder
      } = this.props;
      if (placeholder !== undefined) {
        return placeholder;
      }
      if (isAdditionalProperty) {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        return getDefaultValue('number').toString();
      }
      return null;
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  getFieldRestrictions() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      schema
    } = this.props;
    const restrictions = {
      increment: 1,
      min: null,
      max: null
    };
    if (schema.multipleOf) {
      restrictions.increment = schema.multipleOf;
    }
    if (!isNaN(schema.minimum)) {
      restrictions.min = schema.minimum;
    }
    if (!isNaN(schema.maximum)) {
      restrictions.max = schema.maximum;
    }
    return restrictions;
  }
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      autoFocus,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      collapsed,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      isAdditionalProperty,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry = DEFAULT_REGISTRY,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema
    } = this.props;
    const {
      title,
      format
    } = schema;
    const {
      formContext
    } = registry;
    if (format && !['int64', 'int32'].includes(format)) {
      return /*#__PURE__*/_jsx(UnderConstruction, {
        component: `IntegerField: ${format}`
      });
    }
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(NumberInput
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, Object.assign({
        autoFocus: autoFocus,
        format: format,
        formContext: formContext,
        id: idSchema && idSchema.$id
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
        increment: 1,
        disabled: disabled,
        label: title || name,
        onChange: this.onChange,
        placeholder: this.getPlaceholder(),
        readOnly: readOnly,
        required: required,
        schema: schema,
        step: 1,
        value: formData
      }, this.getFieldRestrictions()))
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
IntegerField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
IntegerField.defaultProps = {
  disabled: false,
  readOnly: false
};